import clsx from 'clsx'
import { motion } from 'motion/react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import { AnimationStage } from './constants'

import style from './text-field.module.scss'

export function TextField({
  stage,
  cardDismissed,
}: {
  stage: AnimationStage
  cardDismissed: boolean
}) {
  const getHighlightBlockProps = (delay: number) => ({
    className: style.highlighterBlock,
    initial: { opacity: 0 },
    animate: { opacity: stage === AnimationStage.TextOnly || cardDismissed ? 0 : 1 },
    transition: { opacity: { duration: 0.3, delay: cardDismissed ? 0 : delay } },
  })

  const getUnderlineProps = (delay: number) => ({
    className: style.underline,
    initial: { scaleX: 0 },
    animate: { scaleX: stage === AnimationStage.TextOnly || cardDismissed ? 0 : 1 },
    transition: { duration: 0.4, delay, ease: 'easeOut' },
    style: { transformOrigin: 'left' },
  })

  return (
    <motion.div
      initial={{ opacity: 0, y: '50%' }}
      animate={{
        opacity: stage === AnimationStage.Reset ? 0 : 1,
        y: stage === AnimationStage.VbarCard && !cardDismissed ? '0%' : '50%',
        filter: stage === AnimationStage.VbarCard && !cardDismissed ? 'blur(4px)' : 'blur(0px)',
      }}
      transition={{
        y: { ease: 'easeInOut' },
        opacity: { duration: stage === AnimationStage.Reset ? 0.5 : 0.8 },
        filter: { duration: 0.5, delay: 0.2 },
      }}
      className={clsx(style.textField, style.mask)}
      style={{
        backgroundImage: `url(${withPublicImageUrl(cardDismissed ? 'intro-proofreader-vbar-card-corrected.svg' : 'intro-proofreader-text.svg')})`,
      }}
    >
      <div className={style.highlighter}>
        <motion.div {...getHighlightBlockProps(0.5)}>
          <motion.div {...getUnderlineProps(1.3)} />
        </motion.div>
        <motion.div {...getHighlightBlockProps(0.55)}>
          <motion.div {...getUnderlineProps(1.5)} />
        </motion.div>
        <motion.div {...getHighlightBlockProps(0.6)}>
          <motion.div {...getUnderlineProps(1.3)} />
          <motion.div {...getUnderlineProps(1.45)} />
          <motion.div {...getUnderlineProps(1.51)} />
        </motion.div>
        <motion.div
          className={style.vbar}
          data-animate={stage === AnimationStage.WithVbar || stage === AnimationStage.VbarCard}
          initial={{ opacity: 1 }}
          animate={{ opacity: stage === AnimationStage.TextOnly || cardDismissed ? 0 : 1 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className={style.vbarIcon}
            initial={{ opacity: 0 }}
            animate={{
              opacity: stage === AnimationStage.TextOnly || cardDismissed ? 0 : 1,
            }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
      </div>
    </motion.div>
  )
}
